import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/fillTransferBookingData', request)
}

export {post}
